export const ASSETS="ASSETS";
export const ASSETS_ID="ASSETS_ID";

export const SET_USER="SET_USER";
export const SET_DURATION="SET_DURATION";
export const SET_ATTACHMNET="SET_ATTACHMNET";
export const SET_ASSETS_ID="SET_ASSETS_ID";
export const SET_STATESET_RENEWAL_DURATION="SET_RENEWAL_DURATION";

export const SEARCH_ASSERTS="SEARCH_ASSERTS";
export const SET_CUSTOMERID="SET_CUSTOMERID";
export const SET_CAT="SET_CAT";
export const SET_FNAME="SET_FNAME";
export const SET_MNAME="SET_MNAME";
export const SET_GENDER="SET_GENDER";
export const SET_DISABILITIES="SET_DISABILITIES";
export const SET_WPNO="SET_WPNO";
export const SET_STATE="SET_STATE";
export const SET_DIST="SET_DIST";
export const SET_BLOCK="SET_BLOCK";
export const SET_VILLAGE="SET_VILLAGE";
export const SET_PIN="SET_PIN";
export const SET_RENEWAL_DURATION="SET_RENEWAL_DURATION";
export const SET_TEN_SCL="SET_TEN_SCL";
export const SET_TEN_SCL_BOARD="SET_TEN_SCL_BOARD";
export const SET_TEN_SCL_PASS="SET_TEN_SCL_PASS";
export const SET_TEN_SCL_FULLMARK="SET_TEN_SCL_FULLMARK";
export const SET_TEN_SCL_FULLMARK_SEC="SET_TEN_SCL_FULLMARK_SEC";
export const SET_CLG="SET_CLG";
export const SET_CLG_BOARD="SET_CLG_BOARD";
export const SET_CLG_PASS="SET_CLG_PASS";
export const SET_CLG_FULLMARK="SET_CLG_FULLMARK";
export const SET_CLG_FULLMARK_SEC="SET_CLG_FULLMARK_SEC";
export const SET_CLG_NEET="SET_CLG_NEET";
export const SET_CLG_NEETATM="SET_CLG_NEETATM";
export const SET_CITY_CENTER="SET_CITY_CENTER";
export const SET_STUDY_CENTER="SET_STUDY_CENTER";
export const SET_PROFILE_PIC="SET_PROFILE_PIC";
export const SET_USER_DATA="SET_USER_DATA";
export const SET_TYPE="SET_TYPE";
export const SET_HOSTEL="SET_HOSTEL";
export const SET_MEDIUM="SET_MEDIUM";
export const SET_PER="SET_PER";
export const SET_EMAIL="SET_EMAIL";


